<template>
  <div class="main-width recommend" v-if="similar.length">
    <h6 class="recommend__title">相关产品推荐</h6>
    <div class="recommend__list">
      <div class="recommend__wrapper">
        <ul class="flex flex-wrap -mx-3.5">
          <li class="w-1/2 px-3.5 mb-8 " v-for="(item, itemIndex) in similar" :key="itemIndex">
            <div class="recommend__item">
              <div class="recommend__item__img">
                <el-image class="img" fit="cover" :src="item.images"></el-image>
              </div>
              <div class="recommend__item__content">
                <p class="recommend__name line-clamp-2">{{ item.name }}</p>
                <p class="recommend__address line-clamp-1">
                  <span>
                    <i class="ficon ficon-chufadi" />
                    {{ item.departure }}出发
                  </span>
                  <span>
                    <i class="ficon ficon-zuijintuanqi" />
                    最近{{ item.date_count }}个团期：{{ item.product_date.join("、") }}
                  </span>
                </p>
                <div class="recommend__tags">
                  <!-- <div class="tag-group overflow-x-auto">
                    <v-tag v-for="(tag, index) in item.tags" :key="index" class="tag" type="blue">{{ tag }}</v-tag>
                  </div> -->
				  <ul class="flex flex-wrap mt-2 h-6 overflow-hidden">
						<li
							class="inline-flex items-center px-1 rounded-sm text-xxs mr-2 mb-2 h-5 border border-[#7378E6] text-[#7378E6]"
							v-for="(child, index) in item.tags"
							:key="index"
						>
							{{ child }}
						</li>
					</ul>
                </div>
                <div class="recommend__footer">
                  <p class="recommend__price">
                    <span class="union">￥</span>
                    <span class="num">{{ item.min_price | toThousandFilter }}</span>
                    <span>起</span>
                  </p>
                  <nuxt-link target="_blank" :to="buildProductDetailLink({product_type:item.product_type, product_no:item.product_no,is_tripartite_product:item.is_tripartite_product})">
                    <div class="recommend__btn">查看详情</div>
                  </nuxt-link>
                </div>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import { buildProductDetailLink } from "@/utils/product";

export default {
	name: "ProductRecommond",
	props: {
		similar: {
			type: Array,
			default: () => []
		}
	},
	methods: {
		buildProductDetailLink
	}
};
</script>

<style lang="scss" scoped>
.recommend__title {
  color: #212529;
  font-size: 18px;
  padding: 35px 0;
}
.recommend__item {
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  position: relative;
  box-shadow: 0px 0px 14px 0px rgba(223, 223, 223, 0.22);
  border-radius: 0 14px 14px 14px;
  background: url("~assets/img/product/recommend_product_bg.png") top right no-repeat;
  background-size: contain;
}
.recommend__item__img {
  position: relative;
  font-size: 0;
  z-index: 1;
}
.recommend__item__img::after {
  content: "热卖";
  line-height: 35px;
  position: absolute;
  text-align: center;
  color: #fff;
  font-size: 18px;
  font-weight: 600;
  width: 60px;
  height: 40px;
  left: -4px;
  top: 0;
  background: url("~assets/img/customer/customer_product_img_tag.png")
  					no-repeat center;
  background-size: cover;
}
.recommend__item__img .img {
  width: 242px;
  height: 182px;
  border-radius: 14px;
  border: 1px solid #fff;
  overflow: hidden;
}
.recommend__item__content {
  padding: 12px 24px;
  flex: 1;
  overflow: hidden;
  position: relative;
}
.recommend__item__content > * {
  position: relative;
}
.recommend__item .ficon {
  color: #adb5bd;
}
.recommend__name {
  color: #212529;
  font-size: 16px;
  font-weight: 500;
  margin-bottom: 10px;
}
.recommend__address {
  color: #495057;
  font-size: 13px;
  margin-bottom: 4px;
}
.recommend__address span:first-child {
  margin-right: 5px;
}
.recommend__footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: absolute;
  bottom: 0;
  right: 0;
  width: 100%;
  padding: 0 24px 12px;
}
.recommend__price {
  color: #606060;
  font-size: 16px;
  display: flex;
  align-items: baseline;
}
.recommend__price .union {
  --tw-text-opacity: 1;
  color: rgba(204, 75, 12, var(--tw-text-opacity));
}
.recommend__price .num {
  font-size: 26px;
  font-weight: 600;
  --tw-text-opacity: 1;
  color: rgba(204, 75, 12, var(--tw-text-opacity));
}
.recommend__btn {
  --tw-border-opacity: 1;
  border-color: rgba(0, 94, 220, var(--tw-border-opacity));
  --tw-text-opacity: 1;
  color: rgba(0, 94, 220, var(--tw-text-opacity));
  border: 1px solid;
  border-radius: 6px;
  display: flex;
  align-items: center;
  font-size: 14px;
  padding: 8px 25px;
  cursor: pointer;
  user-select: none;
}
.recommend__tags {
  width: 280px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
.recommend__tags ::v-deep .v-tag {
  background-color: #fff;
  border-color: #7378E6;
  color: #7378E6;
}
</style>
